var React = require('react');

function RarrowRose (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.2391 0.23576C4.91283 0.549681 4.91283 1.0558 5.2391 1.36972L7.14346 3.202L0.832324 3.202C0.372881 3.202 -1.94261e-07 3.56076 -1.74968e-07 4.00282C-1.55674e-07 4.44487 0.372881 4.80364 0.832324 4.80364L7.14346 4.80363L5.2391 6.64232C4.92615 6.94343 4.92615 7.46876 5.2391 7.77628C5.56537 8.0902 6.0914 8.0902 6.41768 7.77628L9.74697 4.573L9.8069 4.50253C9.84685 4.45768 9.89346 4.39362 9.93341 4.31033C9.97336 4.21423 10 4.10532 10 4.00281L9.99334 3.93234C9.98668 3.84906 9.96671 3.77218 9.93341 3.6953C9.89346 3.59279 9.82687 3.50951 9.75363 3.43263L6.42433 0.229353C6.0914 -0.0781615 5.55872 -0.0781615 5.2391 0.23576Z","fill":"#FF2B5E"}));
}

RarrowRose.defaultProps = {"width":"10","height":"9","viewBox":"0 0 10 9","fill":"none"};

module.exports = RarrowRose;

RarrowRose.default = RarrowRose;
